import React, { FC } from "react";
import { styled } from "styled-components";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import "./Header.css"
import ThemeSwitch from "./ThemeSwitch";

const HeaderArea = styled.div`
    box-sizing: border-box;
    width: 100%;
    max-width: 768px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    padding: 0 24px;
    margin: 24px 0;
`;
const SideBox = styled.div`
    min-width: 10%;

    & button {
        outline: none;
        border: none;
        width: 20px;
        height: 20px;
        background-color: transparent;
        
        cursor: pointer;

        & svg {
            color: var(--text-color);
        }
    }
`;
const CustomLink = styled(Link)`
    color: var(--text-color);
    text-decoration: none;

    display: flex;
    justify-content: center;
    align-items: center;
`;
const HeaderBox = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    /* max-width: 80px; */
    text-align: center;
    border-bottom: 2px solid var(--text-color);
    padding-bottom: 16px;
    margin-bottom: 4px;

    color: var(--text-color);

    font-size: 1.2rem;
    font-weight: 500;

    font-family: Pretendard, sans-serif;

    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
`;

interface HeaderProps {
    isHome?: boolean,
    content?: string
    headerLink?: string
}

const Header:FC<HeaderProps> = ({isHome = false, content = "Poinguinie", headerLink = "/"}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const goReturn = () => {
        navigate('/');
    }
    const showThemeSwitch = [
        '/goodrecord', 
        '/portfolio'
    ].includes(location.pathname);
    return (
        <HeaderArea>
            <SideBox className="back">
                {isHome || <button onClick={goReturn}><IoIosArrowRoundBack size='1.8rem' /></button>}
            </SideBox>
            <CustomLink to={headerLink}>
                <HeaderBox className="header">
                    {content}
                </HeaderBox>
            </CustomLink>
            <SideBox>
                {showThemeSwitch && <ThemeSwitch />}
            </SideBox>
        </HeaderArea>
    );
}

export default Header;